interface StickyHeaderProps {
  referenceNumber: string | null;
}

const LOGO_URL = 'https://files-public.monday.com/use1/90515cd5-3bf5-42c7-b8e8-9206f988e523/BYFUSION-LOGO-RGB-01_1080.png';

export function StickyHeader({ referenceNumber }: StickyHeaderProps) {
  const today = new Date().toLocaleDateString('en-US', { month: 'numeric', day: 'numeric', year: 'numeric' });

  return (
    <header className="sticky top-0 z-30 border-b border-border bg-background print:hidden">
      <div className="mx-auto flex max-w-[900px] items-center justify-between gap-3 px-4 py-3 sm:px-6">
        <div className="flex min-w-0 items-center">
          <img src={LOGO_URL} alt="ByFusion" className="h-6 w-auto shrink-0 object-contain sm:h-7" />
        </div>
        <div className="tnum shrink-0 text-right text-[11px] leading-tight text-muted-foreground sm:text-xs">
          <div className={referenceNumber ? 'font-medium text-primary' : ''}>
            {referenceNumber ?? 'Reference assigned on submission'}
          </div>
          <div>{today}</div>
        </div>
      </div>
    </header>
  );
}
